import { render, staticRenderFns } from "./RevenueStats.vue?vue&type=template&id=bff97840&scoped=true"
import script from "./RevenueStats.vue?vue&type=script&lang=js"
export * from "./RevenueStats.vue?vue&type=script&lang=js"
import style0 from "./RevenueStats.vue?vue&type=style&index=0&id=bff97840&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff97840",
  null
  
)

export default component.exports